// src/components/AppHeader.js

import React from 'react';
import { CreditCardIcon } from '@heroicons/react/24/solid';

const AppHeader = ({ appName, appIcon, credits }) => {
    return (
        <div className="flex items-center justify-between py-1 border-b border-gray-200">
            <div className="flex items-center">
                <img 
                    src="https://assets.apilabz.com/icons/apilabz.png" 
                    alt="API Labz" 
                    className="h-5 w-5 mr-1" 
                />
                <span className="text-xs font-semibold text-gray-700">API Labz</span>
            </div>
            
            <div className="flex items-center">
                <CreditCardIcon className="h-4 w-4 text-green-500 mr-1" />
                <span className="text-xs font-semibold">{credits}</span>
            </div>
        </div>
    );
};

export default AppHeader;